import React, { useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeft, Menu } from 'lucide-react';

const TITLE_MAP = {
  '/': 'de Partie',
  '/inventory': 'Inventory',
  '/recipes': 'Recipes',
  '/catalog': 'Catalog',
  '/shopping-list': 'Shopping List',
  '/meal-planner': 'Meal Plan',
  '/macro-planner': 'Macros',
  '/meal-synthesizer': 'Synthesizer',
  '/budget': 'Budget',
  '/biometrics': 'Biometrics',
  '/workout-protocol': 'Workout',
  '/calendar': 'Calendar',
  '/progressive-overload': 'Overload',
  '/fitness': 'Fitness Log',
  '/brigade': 'Brigade',
  '/ai-recipe': 'Recipe AI',
  '/blog': 'Protocol Library',
  '/feedback': 'Feedback',
  '/upgrade': 'Plans',
  '/settings': 'Settings',
  '/admin': 'Admin',
  '/discover': 'Discover',
  '/community': 'Community',
  '/community/new': 'New Post',
  '/profile': 'Profile',
};

const BACK_ROUTES = new Set([
  '/community/new', '/admin', '/feedback', '/upgrade', '/catalog',
  '/meal-synthesizer', '/ai-recipe',
]);

const SYNC_COLORS = {
  idle:    'rgba(255,255,255,0.15)',
  loading: 'var(--macro-carbs)',
  saving:  'var(--saffron)',
  synced:  'var(--success)',
  error:   'var(--danger)',
};

const MobileHeader = ({ user, syncStatus, onMenuOpen, hidden }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const clickCount = useRef(0);
  const clickTimer = useRef(null);

  const getTitle = () => {
    const path = location.pathname;
    if (TITLE_MAP[path]) return TITLE_MAP[path];
    if (path.startsWith('/community/post/')) return 'Post';
    if (path.startsWith('/community/user/')) return 'Profile';
    if (path.startsWith('/blog/')) return 'Article';
    return 'de Partie';
  };

  const showBack = BACK_ROUTES.has(location.pathname)
    || location.pathname.startsWith('/community/post/')
    || location.pathname.startsWith('/community/user/')
    || location.pathname.startsWith('/blog/');

  const syncColor = SYNC_COLORS[syncStatus] || SYNC_COLORS.idle;

  const handleLogoClick = () => {
    clickCount.current += 1;
    if (clickTimer.current) clearTimeout(clickTimer.current);
    if (clickCount.current >= 3) {
      clickCount.current = 0;
      navigate('/admin');
    } else {
      clickTimer.current = setTimeout(() => { clickCount.current = 0; }, 800);
    }
  };

  return (
    <header className={`mobile-header${hidden ? ' header-hidden' : ''}`} role="banner">
      {showBack ? (
        <button className="mobile-header-back" onClick={() => navigate(-1)} aria-label="Go back">
          <ChevronLeft size={22} aria-hidden="true" />
        </button>
      ) : (
        <button className="mobile-header-menu" onClick={onMenuOpen} aria-label="Open menu">
          <Menu size={22} aria-hidden="true" />
        </button>
      )}

      <div className="mobile-header-center" onClick={handleLogoClick} style={{ cursor: 'default' }}>
        <span className="header-monogram" aria-hidden="true">dP</span>
        <span className="mobile-header-title">{getTitle()}</span>
      </div>

      <div className="mobile-header-right" aria-live="polite" aria-atomic="true">
        {user && (
          <span
            className="mobile-sync-dot"
            style={{ background: syncColor }}
            title={syncStatus}
            aria-label={`Sync status: ${syncStatus}`}
          />
        )}
      </div>
    </header>
  );
};

export default MobileHeader;
